import { ArrowRight, Check } from "lucide-react";
import { Link } from "react-router-dom";
import { AnimatedPage } from "../components/AnimatedPage";
import { CTASection } from "../components/CTASection";
import { PageHero } from "../components/PageHero";
import { Section } from "../components/Section";
import { pricing } from "../data/site";

export default function Pricing() {
  return (
    <AnimatedPage>
      <PageHero
        eyebrow="Pricing"
        title="Flexible packages with custom quotes for every project"
        description="Choose the package that best matches your goal. Lazerwebs scopes each project carefully so the final quote reflects your features, timeline, integrations, and launch needs."
      />
      <Section
        eyebrow="Packages"
        title="Start simple or build something deeply custom"
        description="No fixed prices are listed because every serious digital product deserves accurate scope, not guesswork."
      >
        <div className="grid gap-5 lg:grid-cols-3">
          {pricing.map((plan, index) => (
            <article
              key={plan.name}
              className={`glass-card p-6 ${
                index === 1 ? "border-electric/50 shadow-glow" : ""
              }`}
            >
              <div className="flex items-center justify-between gap-4">
                <h2 className="font-display text-xl font-semibold text-white">
                  {plan.name}
                </h2>
                {index === 1 && (
                  <span className="rounded-full bg-brand-gradient px-3 py-1 text-xs font-semibold text-white">
                    Popular
                  </span>
                )}
              </div>
              <p className="mt-4 text-sm leading-6 text-white/60">
                {plan.description}
              </p>
              <div className="mt-7">
                <p className="text-sm uppercase tracking-[0.22em] text-white/40">
                  From
                </p>
                <p className="mt-2 font-display text-3xl font-semibold text-white">
                  Custom Quote
                </p>
              </div>
              <ul className="mt-7 grid gap-3">
                {plan.features.map((feature) => (
                  <li
                    key={feature}
                    className="flex items-center gap-3 text-sm text-white/70"
                  >
                    <span className="grid h-5 w-5 place-items-center rounded-full bg-electric/15 text-sky-200">
                      <Check className="h-3.5 w-3.5" />
                    </span>
                    {feature}
                  </li>
                ))}
              </ul>
              <Link to="/contact" className="btn btn-primary mt-8 w-full justify-center">
                Get Quote
                <ArrowRight className="h-4 w-4" />
              </Link>
            </article>
          ))}
        </div>
      </Section>
      <CTASection />
    </AnimatedPage>
  );
}
